import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import {TicketConfiguration} from '../../../../Models';
import {VuexObjectMixin} from '../../../../Mixins';
import Vvs from '../../../Icons/Vvs.vue';
import {DEFAULT_LANGUAGE} from '../../../../constants';

@Component({
    components: {Vvs},
})
export default class TicketDescription extends VuexObjectMixin {
  @Prop({type: TicketConfiguration, required: true}) ticketConfiguration: TicketConfiguration | undefined;
  @Prop({type: Boolean, required: false}) soldOut: boolean | undefined;

  get productPurchasable(): boolean {
    if (this.ticketConfiguration) {
      const purchasableFrom = new Date(this.ticketConfiguration.product.bookingPosStart);
      const purchasableUntil = new Date(this.ticketConfiguration.product.bookingPosEnd);
      const now = new Date();
      return (purchasableFrom <= now && purchasableUntil >= now);
    }
    return false;
  }

  get productInfoText(): string {
    const product = this.ticketConfiguration?.product;

    if (product?.infoButtonText) {
      if (this.userLanguage !== DEFAULT_LANGUAGE ) {
        const translations = product.infoButtonText.translations;

        if (translations && this.userLanguage in translations) {
          return translations[this.userLanguage].text || '';
        }
      }
      return product.infoButtonText?.text || '';
    }

    return '';
  }
}
